import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlTemImzaYetkiAramaComponent} from './ctl-tem-imza-yetki-arama/ctl-tem-imza-yetki-arama.component';
import {TemImzaYetkiService} from './ctl-tem-imza-yetki.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-tem-imza-yetki',
  templateUrl: './ctl-tem-imza-yetki.component.html',
  styleUrls: ['./ctl-tem-imza-yetki.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTemImzaYetkiAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
  ],
  providers: [TemImzaYetkiService],
})
export class CtlTemImzaYetkiComponent implements OnInit {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  public toastVisible = false;
  public showAction = true;
  public crudPopupVisible = false;
  public toastMessage: string;
  public title!: string;
  public isFirst = true;
  public control!: any;
  controlName = "TemImzaYetki";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code: any;
  @Input() institutionalCode!: any;
  @Input() period!: number;
  @Input() titleType!: number;
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  @Input() warningMessage: string | null = null;
  // DKM-5331 Cedric (18.10): İSTEĞE BAĞLI aktiflik süzgeci (verilmezse süzgeç ve istekler değişmez).
  /** 'E' → yalnız AKTIF_EH='E' imza yetkilileri listelenir / kodla bulunur. */
  @Input() aktifEh: string | null = null;
  /** Bu tarih itibarıyla görevde olanlar (GOREV_BASLAMA_TARIH ≤ tarih ≤ GOREV_BITIS_TARIH ya da bitiş boş); tarih değişince liste yeniden süzülür. */
  @Input() aktifTarih: Date | string | number | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TemImzaYetkiService, private utilsService: UtilsService, private ortakService: OrtakService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['period'] || changes['institutionalCode']) {
      if (this.period == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.period, this.institutionalCode, this.titleType,this.isReadOnly,this.isBindCheck)
      }
    }
        if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.period, this.institutionalCode, this.titleType,this.isReadOnly,this.isBindCheck)
          }
    // DKM-5331 Cedric (18.10): yalnız giriş bağlıysa çağrılır (bağlı değilse servisteki değerler null kalır)
    if (changes['aktifEh'] || changes['aktifTarih']) {
      this.service.setAktiflik(this.aktifEh, this.aktifTarih);
    }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }

    if (!this.period) {
      this.toastMessage = "Lütfen Dönem Bilgisini Kontrol Ediniz.(Tem İmza Yetki)"
      this.showAction = false
    }

        this.service.setParams(this.period, this.institutionalCode, this.titleType,this.isReadOnly,this.isBindCheck)
  }

  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code,true)
          if (this.isFirst) this.isFirst = false;
        }
      });
  }

  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if (!this.isFirst) this.getData(e);
      this.isFirst = false;
    } else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {

    this.data = this.service.getData(Number(code),this.control, this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length === 1) {
        this.title = '';
        if (result[0].Ad) this.title = this.title + result[0].Ad + ' ';
        if (result[0].Soyad) this.title = this.title + result[0].Soyad + ' ';
        if (result[0].Unvani) this.title = this.title + result[0].Unvani;
        this.code = result[0].Kod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.Kod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
